<!--
 * @Description: 惠税直达服务专区 - 税务政策订阅
 * @Author: LXG
 * @Date: 2021-08-18
 * @Editors: LXG
 * @LastEditTime: 2021-08-22
-->
<template>
  <div class="sw-policy-subscription">
    <header class="pad-tb-1 pad-rl-2 wrap-header">
      <h2 class="enterprise">{{ cpu_enterprise }}</h2>
      <div>
        <span class="marg-rl-1">订阅自身需求偏好标签</span>
        <el-button size="mini" type="primary" @click="showSsDialog">{{
          !!subscribedData.length ? "修改订阅" : "立即订阅"
        }}</el-button>
      </div>
    </header>
    <FilterGroup class="pad-tb-1 pad-rl-2">
      <FilterItem class="search-tag" label="当前订阅" :needAll="false">
        <div
          v-for="(item, index) in subscribedData"
          :key="index"
          class="bord-r-1 tag-item"
        >
          {{ item.labelname || item}}
        </div>
      </FilterItem>
    </FilterGroup>
    <div class="wrap-content">
      <div class="pad-tb-1 pad-rl-2 content-header">
        <!--        <div>
          <el-button
            class="search-release"
            :class="{
              'search-release&#45;&#45;desc': searchInfo.data.releaseTime == 1,
            }"
            type="text"
            @click="changeRelease"
          >
            <span>印发时间</span>
            <i class="el-icon-top"></i>
          </el-button>
          &lt;!&ndash; <el-checkbox
                        class="search-calculate"
                        v-model="searchInfo.data.canCalculate"
                        @change="changeCalculate"
                    >仅显示可计算的政策</el-checkbox> &ndash;&gt;
        </div>-->

        <span class="result">
          <el-button class="computeBtn" round @click="groupTimeGX()"
            >按更新时间排序</el-button
          >
          <el-button class="computeBtn" round @click="groupTimeFB()"
            >按发布时间排序</el-button
          >
        </span>

        <div class="searchbar">
          <FormInput v-model="searchInfo.data.keywords"></FormInput>
          <el-button size="medium" type="primary" @click="changeKeywords"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="content-body">
        <div>
          <div
            v-for="(item, index) in listData"
            :key="index"
            class="pad-1 bord-r-1 marg-tb-1 marg-rl-2 policy-item"
          >
            <div class="pad-rl-1 bord-r-1 policy-zcfs">
              <span
                v-for="(proj, index) in cpu_policyProjectList(item)"
                :key="index"
                v-show="proj.zcname"
                class="zcfs-item"
                >{{ proj.zcname }}</span
              >
              <!-- {{getDictLabel("sq_policy_zjlx", item.zcfs)}} -->
            </div>
            <h3 class="policy-name" @click="toPolicyDetail(item)">
              {{ item.name }}
            </h3>
            <div v-for="(entry,index) in dealEntryNumber(item)" :key="index" v-html="cutout(entry.entryName)">
<!--              <p class="policy-content" >{{index+1}}、{{ entry.entryName.substr(0, 200) }}</p>-->
            </div>
            <div class="policy-infos">
              <div
                v-for="(info, index) in policyInfos"
                :key="index"
                class="info-item"
                :style="{ width: info.width }"
              >
                <label class="info-label">{{ info.label }}：</label>
                <div class="info-value">
                  <template v-if="info.valueFormatter">{{
                    info.valueFormatter(item)
                  }}</template>
                  <template v-else>{{ item[info.valueKey] }}</template>
                </div>
              </div>
            </div>
            <!-- <div class="policy_footer">
              <div style="float: right; display: flex"> -->
                <!--                <el-button
                  v-if="item.isMatch == 1"
                  class="marg-rl-1"
                  size="mini"
                  type="primary"
                  @click="showZcppDialog(item)"
                  >政策匹配</el-button
                >-->
                <!-- <a
                  href="https://12366.chinatax.gov.cn/xiaohui/"
                  target="_blank"
                >
                  <span class="online"><i></i>在线咨询</span>
                </a> -->
                <!-- <span class="yuyue" @click="tonewpage(item)"><i></i>查看</span> -->
              <!-- </div> -->
              <!--              <div class="policy-tag">
                <label>标签：</label>
                <div style="flex: 1">
                  <span
                    v-for="(tag, index) in item.policyClassificationValue"
                    :key="index"
                    class="marg-rl-2"
                    >{{ tag }}</span
                  >
                </div>
              </div>-->
            <!-- </div> -->
          </div>
        </div>
        <el-pagination
          class="marg-tb-2"
          style="text-align: center"
          background
          layout="prev,pager,next,total,jumper"
          :current-page.sync="pageInfo.page"
          :page-size.sync="pageInfo.size"
          :total="pageInfo.total"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>
    <TjCommonDialog ref="ssDialog" class="ss-dialog">
      <div class="module">
        <h2>当前已订阅</h2>
        <div class="pad-rl-2" style="overflow: auto">
          <el-button style="float: right" type="primary" @click="clearLable"
            >清空</el-button
          >
          <div class="tag-list">
            <el-tag
              v-for="(item, index) in temp_subscribedData"
              :key="index"
              class="tag-item"
              type="danger"
              @close="temp_subscribedData.splice(index, 1)"
              >{{ item.labelname || item }}</el-tag
            >
          </div>
        </div>
      </div>
      <div class="module">
        <h2>可选择订阅</h2>
        <!-- <div class="pad-rl-2">
          <el-tag
            v-for="(item, index) in cpu_subscriptionData"
            :key="index"
            class="clickable tag-item"
            type="danger"
            @click="temp_subscribedData.push(item)"
            >{{ item.labelname }}</el-tag
          >
        </div> -->
        <FilterGroup class="pad-tb-1 pad-rl-2" @change="chooseChange">
          <FilterRadio
            label="一级"
            layer="0"
            :list="cpu_typeList"
            valueKey="valueKey"
            labelKey="labelKey"
            :needAll="false"
            ref="check1"
            style="height: 128px"
          ></FilterRadio>
          <FilterRadio
            label="二级"
            style="height: 128px"
            :list="childrenData"
            layer="1"
            valueKey="labelcode"
            labelKey="labelname"
            class="search-tag"
            ref="check2"
            :needAll="false"
            v-if="childrenData.length != 0"
          >
            <!-- <div
            v-for="(item, index) in cpu_tagList"
            :key="index"
            class="bord-r-1 tag-item"
            :class="{
              'tag--active': item.choose == 1,
            }"
            @click="changeTag(item, index)"
          >
            {{ item.labelname }}
          </div> -->
          </FilterRadio>
          <el-divider></el-divider>
          <div class="search-tag1" style="height:300px;overflow-y: auto;">
            <FilterCheckBox
              label="三级"
              :list="childrenData2"
              layer="2"
              valueKey="labelcode"
              labelKey="labelname"
              class="search-tag"
              :needAll="false"
              ref="check3"
              v-if="childrenData2.length != 0"
            ></FilterCheckBox>
          </div>

          <!-- <div
            v-for="(item, index) in cpu_tagList2"
            :key="index"
            class="bord-r-1 tag-item"
            :class="{
              'tag--active': item.choose == 1,
            }"
            @click="changeTag(item, index)"
          >
            {{ item.labelname }}
          </div> -->
        </FilterGroup>
      </div>
      <template v-slot:footer>
        <el-button @click="closeSsDialog">取消</el-button>
        <el-button type="primary" @click="confirmSsDialog">确定</el-button>
      </template>
    </TjCommonDialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $tjCommonDialog from "@/components/tj-common-dialog/index.js";
import {
  FilterGroup,
  FilterCheckBox,
  FilterItem,
  FilterRadio,
} from "@/views/findList/components/filter/index.js";
import { FormInput } from "@/components/form/index.js";
import { LOGIN_URL, LOGIN_URL_BACK } from "@/store/mutation-types";
import TjCommonDialog from "@/components/tj-common-dialog/TjCommonDialog";

export default {
  name: "SwPolicySubscription",
  components: {
    FilterGroup,
    FilterItem,
    FilterCheckBox,
    FilterRadio,
    FormInput,
    TjCommonDialog,
  },
  filters: {},
  props: {},
  data() {
    return {
      typeIndex: "", //政策标签上次二级标签选中值
      datamap:{}, //当前选中的三级标签的二级标签ID
      datamap2:{}, //当前选中的三级标签的二级标签ID
      datalist:[], //当前选中的三级标签的二级标签ID
      childrenData: [],
      childrenData2: [],
      subscribedData: [], // 已订阅标签数据
      temp_subscribedDataKey: [],
      temp_subscribedData: [], // 已订阅标签数据(暂存)
      // 可订阅标签数据
      subscriptionData: [
        // { id: '', labelcode: '0', labelname: '增值税' },
      ],
      searchInfo: {
        data: {
          iam: "", // 我是
          type: "", // 我要找(税类型)
          secondTag: "", //二级标签
          thirdTag: "", //三级标签
          tag: [], // 标签
          flag: [], // 标签变红
          keywords: "", // 关键字
          releaseTime: 1, // 印发时间排序
          canCalculate: false, // 是否可计算
        },
        typeTagData: [], // 类型及标签数据
        typeTagData2: [], // 类型及标签数据（点不限使用）
      },
      // 政策列表数据
      listData: [],
      policyInfos: [
        {
          width: "200px",
          label: "政策等级",
          valueFormatter: (item) => {
            if (!item.areaid) return "--";
            return this.getDictLabel("areaLevel", item.areaid);
          },
        },
        {
          width: "400px",
          label: "发文单位",
          valueKey: "fbjg",
        },
        {
          label: "发布日期",
          valueKey: "publictime",
        },
      ],
      pageInfo: {
        page: 1,
        size: 10,
        total: 0,
      },
      sortByType: 1, //  0 是更新时间排序    1是发布时间排序
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      token: "getToken",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    cpu_enterprise() {
      if (!this.userInfo) return "";
      return this.userInfo?.enterpriseInfo?.enterprise || "";
    },
    /**
     * @description: 可选择订阅的标签列表
     * @return {Array}
     */
    cpu_subscriptionData() {
      return this.subscriptionData.filter((cv) => {
        return !this.temp_subscribedData.some((s) => s.id === cv.id);
      });
    },
    cpu_policyProjectList() {
      return function (policy) {
        return policy.cfgPermitItemInfoList || [];
      };
    },
    dealEntryNumber(){
      return function (item) {
        if(item.entrys.length>3){
          return item.entrys.slice(0,3);
        }else {
          return item.entrys || [];
        }
      };
    },
    cpu_typeList() {
      //this.searchInfo.typeTagData;
      // return this.searchInfo.typeTagData.filter((cv) => cv.parentId == "0");
      let arr = [];
      this.searchInfo.typeTagData.forEach((item, index) => {
        arr[index] = {
          labelKey: item.labelname,
          valueKey: item.labelcode,
        };
      });
      return arr;
    },
    cpu_tagList() {
      // 标签的parentId为父类的id

      // let arr = this.searchInfo.typeTagData.filter((cv) => cv.parentId == "0");
      // if (!this.searchInfo.data.type) return arr;
      // let temp = [];
      // arr.forEach((item) => {
      //   if (item.id == this.searchInfo.data.type) {
      //     temp = item.children;
      //   }
      // });
      let arr = [];
      this.searchInfo.typeTagData.forEach((item) => {
        if (item.children && item.children.length != 0) arr.push(item.children);
      });
      let temp = [];
      arr.forEach((item, index) => {
        temp[index] = {
          labelKey: item[0].labelname,
          valueKey: item[0].labelcode,
        };
      });
      return temp;
    },
    cpu_tagList2() {
      let temp = this.cpu_tagList;
      let arr = [];
      temp.forEach((item) => {
        if (item.children && item.children.length != 0) arr.push(item.children);
      });
      let tagArr = [];
      arr.forEach((item, index) => {
        tagArr[index] = {
          labelKey: item[0].labelname,
          valueKey: item[0].labelcode,
        };
      });
      return tagArr;
    },
  },
  methods: {
    cutout(cellValue) {
      cellValue = cellValue.replace(/(^\s*)|(\s*$)/g, "");
      if(cellValue.length>80){
        cellValue = cellValue.substr(0, 80)+"..."
      }
      return cellValue
    },
    chooseChange(val1, val2, val3, layer) {
      this.searchInfo.data.tag = [];
      let temp = [];
      let temp2 = [];
      let list = [];
      if (layer == "0") {
        //单选
        temp = val2;
        temp2 = val3;
        this.childrenData = [];
        this.childrenData2 = [];
        list = this.searchInfo.typeTagData;
        list.forEach((items) => {
          if (items.labelcode == temp) {
            if (items.children && items.children.length != 0) {
              items.children.forEach((item1) => {
                this.childrenData.push(item1);
              });
            }
          }
        });
        if (this.$refs.check2) {
          this.$refs.check2.cleanBoxList();
        }
      } else if (layer == "1") {
        //单选
        this.typeIndex = val2;
        temp = val2;
        temp2 = val3;
        this.childrenData2 = [];
        this.searchInfo.typeTagData.forEach((item) => {
          if (item.children && item.children.length != 0)
            item.children.forEach((item1) => {
              list.push(item1);
            });
        });
        list.forEach((items) => {
          if (items.labelcode == temp) {
            if (items.children && items.children.length != 0) {
              items.children.forEach((item1) => {
                this.childrenData2.push(item1);
              });
            }
          }
        });
        if (this.$refs.check3) {
          this.$refs.check3.cleanBoxList();
        }
      } else {
        if (val2 != "") {
          temp = val2.split(",");
          temp2 = val3.split(",");
        }
        this.datamap[this.typeIndex] = temp
        this.datamap2[this.typeIndex] = temp2
        if(this.datalist.indexOf(this.typeIndex)==-1){
          this.datalist.push(this.typeIndex)
        }
        this.temp_subscribedData = []
        this.temp_subscribedDataKey = []
        this.datalist.forEach((item) => {
          this.temp_subscribedData = this.temp_subscribedData.concat(this.datamap[item])
          this.temp_subscribedDataKey = this.temp_subscribedDataKey.concat(this.datamap2[item])
        });
      }
    },
    changeTag(item, index) {
      if (item.choose == "1") {
        item.choose = "0";
        this.setJieDian(item);
      } else {
        item.choose = "1";
      }
      this.tempParam = [];
      this.searchInfo.typeTagData.forEach((item0) => {
        // 此方法是二三级标签点击方法 不考虑第一级
        item0.children.forEach((item2) => {
          if (item2.choose == "1") {
            this.dealChildren(item2);
          }
        });
      });
      this.searchInfo.data.tag = this.tempParam;
      if (item.layer == "2") {
        this.childrenData = item.children;
        if (item.choose == "0") {
          this.childrenData = [];
        }
      }

      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },
    //按照发布时间
    groupTimeFB() {
      this.sortByType = 1;
      this.queryListData();
    },
    //按照更新时间
    groupTimeGX() {
      this.sortByType = 0;
      this.queryListData();
    },

    /**
     * @description: 打开订阅弹窗
     */
    showSsDialog() {
      this.temp_subscribedData = JSON.parse(
        JSON.stringify(this.subscribedData)
      );
      this.$refs["ssDialog"].open();
    },
    /**
     * @description: 关闭订阅弹窗
     */
    closeSsDialog() {
      this.$refs["ssDialog"].close();
    },
    /**
     * @description: 清空已选择的
     */
    clearLable() {
      this.datalist = [];
      this.datamap = {};
      this.datamap2 = {};
      this.temp_subscribedData=[];
      this.$refs.check1.cleanBoxList();
      this.$refs.check2.cleanBoxList();
      this.$refs.check3.cleanBoxList();
    },
    confirmSsDialog() {
      // 至少订阅一个标签
      if (!this.temp_subscribedData.length) {
        this.$message.warning("至少订阅一个标签");
        return;
      }
      this.subscribedData = JSON.parse(
        JSON.stringify(this.temp_subscribedData)
      //JSON.stringify(this.temp_subscribedDataKey)
      );
      this.$refs["ssDialog"].close();

      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData(1);
      this.postSubscription();
    },
    /**
     * @description: 修改搜索条件 印发时间排序
     */
    changeRelease() {
      this.searchInfo.data.releaseTime = this.searchInfo.data.releaseTime ^ 1;

      this.listData = [];
      this.pageInfo.page = 1;
      this.queryListData();
    },
    /**
     * @description: 修改搜索条件 是否可计算
     */
    changeCalculate() {
      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },
    /**
     * @description: 修改搜索条件 关键字
     */
    changeKeywords() {
      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },
    /**
     * @description: 前往政策详情页面
     * @param {Object} policy 政策
     */
    toPolicyDetail(policy) {
      window.sessionStorage.setItem("policyDetailData", JSON.stringify(policy));
      window.sessionStorage.setItem("flag", true);
      window.sessionStorage.setItem("status", true);
      // this.$router.push({
      //   name: "showPolicyDetail",
      //   query:{
      //     showSideNav:true,
      //   }
      // });
      let { href } = this.$router.resolve({
					name: "showPolicyDetail",
           query:{
            showSideNav:true,
          }
				});
		  window.open(href, "_blank");
    },
    /**
     * @description: 弹出政策匹配组件
     * @param {Object} policy 政策
     */
    showZcppDialog(policy) {
      $tjCommonDialog.init({
        title: "政策匹配",
        height: "80vh",
        contentComponent: () => import("./PolicyMatching"),
        contentBind: {
          zcid: policy.id,
          policyName: policy.name,
        },
      });
    },
    /**
     * @description: 切换页码
     * @param {Number} page 页码
     */
    changePage(page) {
      this.listData = [];
      this.queryListData();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    /**
     * @description: 查询税类型及标签
     */
    queryTypeAndTag() {
      // let url = `/label/warehouse/list?industry=国家税务总局信阳市税务局`
      // let url = `/label/warehouse/allList?industryid=${window.encodeURI(
      //   "001003025"
      // )}`;
      let params = {
        industryid: "001003025",
        isAll: true,
      };
      //let url = `/label/warehouse/allListByIndustry`;
      let url = `/label/warehouse/list`;
      let that = this;
      that.$httpApi.get(url, params).then((res) => {
        console.log("queryTypeAndTag:", res);
        if (res.code == 200) {
          that.searchInfo.typeTagData = res.data || [];
          that.subscriptionData = (res.data || []).map((cv) => {
            return {
              id: cv.id,
              labelcode: cv.labelcode,
              labelname: cv.labelname,
            };
          });
        }
      });
    },
    // queryTypeAndTag() {
    //   let params = {
    //     industrys: "",
    //     isAll: true,
    //   };
    //   let url = `/label/warehouse/allListByIndustry`;
    //   // let url = `/label/warehouse/list?industry=${window.encodeURI(
    //   //   "国家税务总局信阳市税务局"
    //   // )}`;
    //   this.$httpApi.post(url, params).then((res) => {
    //     if (res.code == 200) {
    //       this.treeData = res.data || [];
    //       let arr = this.flatTree(res.data)
    //     }
    //   });
    // },

    /**
     * @description: 查询当前用户已订阅的标签
     */
    querysubscribedData() {
      // TODO
      // 查询用户已订阅标签
      let that = this;
      let url = `/baseLabel/baseLabel/getLabelInfo/${this.userInfo.enterpriseInfo.id}`;
      let params = {};
      that.$httpApi.get(url, params).then((res) => {
        if (res.code == 200 && res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i]) {
              that.subscribedData.push({
                id: res.data[i].id,
                labelcode: res.data[i].labelcode,
                labelname: res.data[i].labelname,
              });
              if(!this.datamap[res.data[i].parentCode]){
                this.datamap[res.data[i].parentCode] = []
                this.datamap2[res.data[i].parentCode] = []
              }
              this.datamap[res.data[i].parentCode].push(res.data[i].labelname)
              this.datamap2[res.data[i].parentCode].push(res.data[i].labelcode)
              if(this.datalist.indexOf(res.data[i].parentCode)==-1){
                this.datalist.push(res.data[i].parentCode)
              }
            }
          }
          // that.subscribedData = res.data.map((cv) => {
          //   if(!!cv){
          //     return {
          //       id: cv.id,
          //       labelcode: cv.labelcode,
          //       labelname: cv.labelname,
          //     };
          //   }
          // });
          // 如果用户还没订阅过，主动提示订阅
          if (!that.subscribedData.length) {
            //that.showSsDialog();
          } else {
            that.queryListData();
          }
        }
      });
    },
    /**
     * @description: 查询政策列表
     */
    queryListData(index) {
      let url = `/sqzd/policy/policyInfoList?pageNum=${this.pageInfo.page}&pageSize=${this.pageInfo.size}`;
      // let url = '/elastic/search/sq-policy'
      let remark = "";
      if (index == 1) {
        remark = this.temp_subscribedDataKey.join(",");
      } else {
        remark = this.subscribedData.map((cv) => cv.labelcode).join(",");
      }
      let params = {
        fbjg: "国家税务总局信阳市税务局",
        deptId: "001003025",
        remark: remark,
        // orderBy: this.searchInfo.data.releaseTime == 1 ? "desc" : "asc",
        name: this.searchInfo.data.keywords,
        orderBy: this.sortByType,
      };
      this.$httpApi.post(url, params).then((res) => {
        if (res.rows && !!res.rows.length) {
          this.listData = res.rows;

          this.pageInfo.total = res.total;
        }
      });
    },
    /**
     * @description: 订阅政策标签
     */
    postSubscription() {
      let url = "/baseLabel/baseLabel/bing";
      let params = this.temp_subscribedDataKey.map((cv) => {
        return {
          labelid: cv,
          qiyeid: this.userInfo.enterpriseInfo.id,
        };
      });
      this.$httpApi.post(url, params).then((res) => {
        console.log("postSubscription:", res);
        if (res.code == 200) {
        }
      });
    },
    tonewpage(item) {
      sessionStorage.setItem("policyContData", JSON.stringify(item));
      sessionStorage.setItem("topNavFlag", 1);
      this.$router.push({ name: "showPolicyCont" });
    },
  },
  watch: {},
  created() {
    /*console.log("userInfo:", this.userInfo);
    this.querysubscribedData();*/
  },
  mounted() {
    setTimeout(() => {
      // 该页面需要登录，若未登录，提示并重定向到 单点登录页面
      if (!this.token && !this.userInfo) {
        let cf = window.confirm("登录后即可访问'税务政策订阅'，即将前往登录");
        if (cf) {
          // let url = `${LOGIN_URL}?refer=cp&backUrl=${LOGIN_URL_BACK}`;
          // url += `?targetUrl=${window.location.host}`;
          // window.location.href = url;
          this.$router.push({ path: "/login2" });
          //window.location.href = "http://222.141.201.20:8060/#/login2"
        } else {
          this.$router.go(-1);
        }
        return;
      }
      this.queryTypeAndTag();
      // this.queryListData();
      this.querysubscribedData();
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
.wrap-header {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 2rem;
  background-color: #ffffff;
}
.enterprise {
  font-weight: normal;
  color: #333333;
}
::v-deep .filter-group {
  margin-bottom: 2rem;

  .filterItem-label {
    font-size: 1rem;
  }
}
::v-deep .filter-item {
  &.search-tag {
    // .filterItem-content {
    //   gap: 1rem;
    // }
    .tag-item {
      padding: 0.1rem 0.5rem;
      border: 1px solid #666666;
    }
  }
}
.wrap-content {
  background-color: #ffffff;
}
.content-header {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #1472FF;
}
.search-release {
  font-size: 1rem;
  color: $col-theme;

  .el-icon-bottom {
    font-weight: bold;
  }

  &.search-release--desc .el-icon-top {
    transform: rotate(180deg);
  }
}
::v-deep .search-calculate {
  margin-left: 2rem;
  font-size: 1rem;

  .el-checkbox__label {
    line-height: 1rem;
    font-size: 1rem;
  }
}
.el-divider--horizontal{
  margin: 0;
}
.searchbar {
  display: -webkit-flex;
  display: flex;
  align-items: center;

  ::v-deep .form-input .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.content-body {
  min-height: 5rem;
  overflow: auto;
}
.policy-item {
  border: 1px solid rgba($col-theme, 0.5);
  -webkit-transition: all 0.4s ease 0s;
  -moz-transition: all 0.4s ease 0s;
  -o-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;

  .policy-zcfs {
    .zcfs-item {
      display: inline-block;
      border: 1px solid $col-theme;
      color: $col-theme;
    }
  }
  .policy-name {
    color: #000000;
    cursor: pointer;

    &:hover {
      color: $col-theme;
    }
  }
  .policy-content {
    color: #000000;
  }
  .policy-infos {
    display: -webkit-flex;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 5px;

    .info-item {
      display: -webkit-flex;
      display: flex;
      align-items: flex-start;

      .info-value {
        flex: 1;
        min-width: 0;
      }
    }
  }
  .policy_footer {
    padding-top: 5px;
    padding-bottom: 5px;
    border-top: 1px solid rgba($col-theme, 0.5);
    margin-top: 5px;
    overflow: auto;
  }
  .online {
    display: flex;
    align-items: center;
    color: red;
    margin-right: 10px;
    cursor: pointer;
    i {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-position: center;
      background-image: url("~@/assets/images/online.png");
    }
  }
  .policy-tag {
    display: -webkit-flex;
    display: flex;
    align-items: flex-start;
  }
  &:hover {
    box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.1);
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}
::v-deep .ss-dialog {
  .module {
    margin-bottom: 1rem;

    h2 {
      margin-bottom: 0.5rem;
      font-weight: normal;
      color: $col-theme;
    }
    // .filterItem-label {
    //   display: none;
    // }
  }
  .tag-list {
    margin-bottom: -5px;
    overflow: hidden;
  }
  .tag-item {
    margin-right: 10px;
    margin-bottom: 5px;
    font-size: 1rem;
    color: $col-theme;
  }
}
::v-deep {
  .el-input--medium {
    width: 300px !important;
  }
  .result {
    font-size: 18px;
    right: 36px;
  }
}
::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background-color: red !important;
  box-shadow: -1px 0 0 0 #fef0f0;
}
// ::v-deep .el-radio-button.is-active {
//   position: relative;
//   &::after {
//     position: absolute;
//     content: "";
//     top: 28px;
//     left: calc(50% - 55px);
//     display: block;
//     width: 30px;
//     height: 26px;
//     background-image: url("~@/assets/images/下-三角.png");
//     background-size: 100% 100%;
//   }
// }
.search-tag1 {
  ::v-deep .el-checkbox-button.is-checked {
    position: relative;
    &::after {
      display: none;
      position: absolute;
      content: "";
    }
  }
}
.yuyue {
  display: flex;
  align-items: center;
  color: red;
  margin-right: 10px;
  cursor: pointer;
}
.yuyue i {
  background-image: url("~@/assets/images/yuyue.png");
}
</style>
